// ============================================================
// buttons.ts — the ONE shared primary-button style (Batch E).
//
// Decision (Jackson): primary buttons are GREEN; gold is a restrained
// accent only ("You" markers, favourite star, the "now" marker) — see
// docs/casevo-design-language.md §3.3.
//
// Colour comes from the casevo-primary / casevo-primary-hover tokens
// (index.css). In light they equal casevo-brand / casevo-mid (no visual
// change); in dark they stay a deep green so white text keeps ≥ 4.5:1
// (dark casevo-brand #52a87f was 2.9:1). `casevo-focus` is the shared
// keyboard focus ring.
//
// Two sizes, same recipe:
//   BTN_PRIMARY_SM — toolbar / page-header actions ("+ New", "New task")
//   BTN_PRIMARY_MD — modal footer actions (Save / Create / Edit)
// ============================================================

export const BTN_PRIMARY =
  'inline-flex items-center justify-center gap-1.5 font-semibold text-white bg-casevo-primary ' +
  'hover:bg-casevo-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed ' +
  'focus:outline-none casevo-focus'

export const BTN_PRIMARY_SM = `${BTN_PRIMARY} text-xs uppercase tracking-widest rounded-md px-4 py-2`

export const BTN_PRIMARY_MD = `${BTN_PRIMARY} text-sm rounded-lg px-5 py-2.5`

// Secondary (outlined, neutral) — used where a second "create" affordance
// would otherwise compete with the surface's one primary (e.g. My Work's
// empty-state "New task" under the header's primary "New task").
export const BTN_SECONDARY_SM =
  'inline-flex items-center justify-center gap-1.5 font-semibold text-xs uppercase tracking-widest ' +
  'rounded-md px-4 py-2 border border-casevo-border bg-casevo-surface text-casevo-brand ' +
  'hover:border-casevo-mid transition-colors disabled:opacity-50 focus:outline-none casevo-focus'
